<ng-container *ngIf='user?.REPORT_ID'>
	<div>
		<span style="margin-left: 10px;" [title]="user?.PROJECT_NUMBER" class="gray">Project Number: </span>
		<span [title]="user?.PROJECT_NUMBER">{{user?.PROJECT_NUMBER.substring(0, 20)}}<span *ngIf="user?.PROJECT_NUMBER.length>20"></span></span>
		<i class="fas fa-chevron-down ml-1" style="color:#c2d63e" (click)="op.toggle($event)"></i><br>
		<p-overlayPanel #op [appendTo]="'body'" [dismissable]="true" [style]="{width: '300px'}">
			<ng-template pTemplate>
				<div style="width: 280px; margin: 4px 10px; padding-right:0; color:#C2D63F;font-size:.8em">
					<label style="font-weight:bold">Reports in Project: </label><br>
					<ng-container *ngFor="let rpt of rpts">
						<a [href]="'report/'+rpt.PROJECT_ID+'/'+rpt.REPORT_ID" target='_blank' [ngClass]="{'disabled':rpt.REPORT_ID==user.REPORT_ID}">{{rpt.REPORT_TITLE}}</a><br>
					</ng-container>
				</div>
			</ng-template>
		</p-overlayPanel>
		<span style="margin-left: 10px;" [title]="user?.FULL_ADDRESS" class="gray">Property Address: </span>
		<span [title]="user?.FULL_ADDRESS">{{user?.FULL_ADDRESS.substring(0, 20)}}<span *ngIf="user?.FULL_ADDRESS.length>20"></span></span>
	</div>
	<div>
		<span style="margin-left: 10px;" [title]="user?.REPORT_TITLE" class="gray">Report Type: </span>
		<span [title]="user?.REPORT_TITLE">{{user?.REPORT_TITLE.substring(0, 20)}}<span *ngIf="user?.REPORT_TITLE.length>20"></span></span>
		<br>
		<span style="margin-left: 10px;" [title]="user?.PROPERTY_NAME" class="gray">Property Name: </span>
		<span [title]="user?.PROPERTY_NAME">{{user?.PROPERTY_NAME.substring(0, 20)}}<span *ngIf="user?.PROPERTY_NAME.length>20"></span></span>
	</div>
	<ng-container *ngIf="!isPhotoLog()">
		<div>
			<span style="margin-left: 10px;" [title]="user?.TEMPLATE[0]?.TEMPLATE_TITLE" class="gray">Template Name: </span>
			<span [title]="user?.TEMPLATE[0]?.TEMPLATE_TITLE">
				<a [href]="'template/'+user?.TEMPLATE[0]?.TEMPLATE_ID" target='_blank'>
					{{user?.TEMPLATE[0]?.TEMPLATE_TITLE.substring(0, 15)}}<span *ngIf="user?.TEMPLATE[0]?.TEMPLATE_TITLE.length>15"></span>
				</a>
			</span><br>
			<span style="margin-left: 10px;" [title]="user?.TEMPLATE[0]?.CATEGORY_NAME" class="gray">Template Category: </span>
			<span [title]="user?.TEMPLATE[0]?.CATEGORY_NAME">{{user?.TEMPLATE[0]?.CATEGORY_NAME.substring(0, 15)}}<span *ngIf="user?.TEMPLATE[0]?.CATEGORY_NAME.length>15"></span></span><br>
			<span style="margin-left: 10px;" [title]="user?.TEMPLATE[0]?.TEMPLATE_VERSION_NO" class="gray">Template Version No#: </span>
			<span >{{user?.TEMPLATE[0]?.TEMPLATE_VERSION_NO}}</span>
		</div>
		<div>
			<span style="margin-left: 10px;" class="gray">Status: </span>
			<span>{{user?.STATUS}}</span>
			<i class="btn-outline-dark btn-small fas fa-chevron-down p-0 ml-1" style="color:#c2d63e" (click)="op1.toggle($event)"></i>
			<p-overlayPanel #op1 [appendTo]="'body'" [dismissable]="true">
				<ng-template pTemplate>
					<div style="width: 140px; margin: 4px 5px; padding-right:0; color:#C2D63F;font-size:.8em">
						<ng-container *ngFor="let item of statusList">
							<a [ngClass]="{'disabled':item.STATUS==user.STATUS}" (click)="op1.hide(); user.STATUS=item.STATUS; changeStatus(item.STATUS)">{{item.STATUS}}</a><br>
						</ng-container>
					</div>
				</ng-template>
			</p-overlayPanel>
			<br>
			<span style="margin-left: 10px;" class="gray">File: </span>
			<span class="mr-2"><a href="javascript:void(0)" (click)="getRUrl()" [ngClass]="{'disabled':loading}"><i class="fas fa-file-pdf" title="PDF File"></i></a></span>
			<span *ngIf="user?.ZIP_FILE" class="mr-2"><a [href]="user?.ZIP_FILE" target=_blank title="ZIP File" ><i class="fas fa-file-archive"></i></a></span>
			<span *ngIf="user?.REPORT_URL" class="mr-2"><a href="javascript:void(0)" title="Generate Word" [ngClass]="{'disabled':loading}" (click)="generateWord()"><i class="fas fa-file-word"></i></a></span>
			<span *ngIf="user?.CLOSER_XML_FILE" class="mr-2"><a href="javascript:void(0)" title="Closer XML File" [ngClass]="{'disabled':loading}" (click)="downloadFile2(user.CLOSER_XML_FILE)"><i class="fas fa-file-code"></i></a></span>
			<span *ngIf="loading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block"></span>
			<!--<a *ngIf="user?.REPORT_URL.length>0" href="javascript:void(0)" class="noteLabel ml-2" (click)="copyRUrl()">Copy PDF Link</a>-->
		</div>
	</ng-container>
</ng-container>
<ng-container *ngIf='user?.TEMPLATE_TYPE'>
	<div>
		<span style="margin-left: 10px;" class="erisGreen">Template Name: </span>
		<span>
			{{user?.TEMPLATE_TITLE}}
			<a class="ml-1" style="cursor:pointer;" (click)="op2.toggle($event);" title="Edit Template title"><i class="erisGreen fas fa-pen"></i></a>
			<p-overlayPanel #op2 [appendTo]="'body'">
				<ng-template pTemplate>
					<input class="rptInfo" style="width:300px;" type="text" [(ngModel)]="user.TEMPLATE_TITLE">
					<button (click)="updateTemplateTitle(user); op2.hide()" class="btn m-0 uploadBtn">Save</button>
				</ng-template>
			</p-overlayPanel>
		</span>
		<br>
		<span style="margin-left: 10px;" class="erisGreen">Template Category: </span>
		<span>{{user?.TEMPLATE_TYPE[0].CATEGORY_NAME}}</span><br>
		<!--<span style="margin-left: 10px;" [title]="user?.TEMPLATE_VERSION_NO" class="erisGreen">Template Version No#: </span>
			<span >{{user?.TEMPLATE_VERSION_NO}}</span>-->
	</div>
	<div>
		<span style="margin-left: 10px;" class="erisGreen">Template Identifier: </span>
		<span>{{user?.TEMPLATE_TYPE[0].SUBCATEGORY_NAME}}</span>
	</div>
</ng-container>
<ng-container *ngIf='user?.COVERPAGE_ID'>
	<span style="margin-top:10px">
		<strong>Cover Page Name: </strong>
		{{user?.COVERPAGE_TITLE}}
		<a class="ml-1" *ngIf="!hide" style="cursor:pointer;" (click)="op3.toggle($event);" title="Edit Coverage title"><i class="erisGreen fas fa-pen"></i></a>
		<p-overlayPanel #op3 [appendTo]="'body'">
			<ng-template pTemplate>
				<input class="rptInfo" style="width:300px" type="text" [(ngModel)]="user.COVERPAGE_TITLE">
				<button (click)="updateCoverpageTitle(user); op3.hide()" class="btn m-0 uploadBtn">Save</button>
			</ng-template>
		</p-overlayPanel>
	</span>
</ng-container>
<ng-container *ngIf='user?.HEADERFOOTER_ID'>
	<span style="margin-top:10px">
		<strong>
			<ng-container *ngIf="user?.TYPE=='HEADER'">
				Header Name:
			</ng-container>
			<ng-container *ngIf="user?.TYPE=='FOOTER'">
				Footer Name:
			</ng-container>
		</strong>
		{{user?.HF_TITLE}}</span>
</ng-container>